
@if (visible) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-slate900/40 p-4 sm:p-6"
    >
    <div class="w-[466px] max-w-[calc(100vw-5rem)] rounded-[8px] bg-white p-6 shadow-2xl">
      <div class="flex flex-col gap-[24px]">
        <div class="flex justify-center m-0">
          <app-icon-reusable [icon]="icon" [size]="44"></app-icon-reusable>
        </div>
        <div>
          <div class="text-center SBH6">
            {{ title }}
          </div>
          <p class="mx-auto mt-4 w-full text-center leading-[1.35] font-normal text-slate600 " style="font-size: 14px;">
            {{ message }}
          </p>
        </div>
        <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-center">
          <div class="w-full sm:w-auto sm:min-w-[156px]">
            <app-button-reusable
              [variant]="confirmVariant"
              [appearance]="'filled'"
              [size]="'md'"
              [fullWidth]="true"
              [loading]="loading"
              [extraClasses]="'whitespace-nowrap'"
              (clicked)="onConfirm()"
              >
              {{ confirmText }}
            </app-button-reusable>
          </div>
          <div class="w-full sm:w-auto sm:min-w-[156px]">
            <app-button-reusable
              [variant]="'neutral'"
              [appearance]="'outline'"
              [size]="'md'"
              [fullWidth]="true"
              [disabled]="loading"
              [extraClasses]="'whitespace-nowrap'"
              (clicked)="onCancel()"
              >
              {{ cancelText }}
            </app-button-reusable>
          </div>
        </div>
      </div>
    </div>
  </div>
}
